"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Head;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _config = _interopRequireDefault(require("@dom/config"));

Head.defaultProps = {
  image: _config["default"].HONEYGUIDE_DEFAULT_IMAGE
};

function Head(props) {
  var description = props.description,
      image = props.image,
      noCrawl = props.noCrawl,
      schema = props.schema,
      canonicalUrl = props.canonicalUrl,
      children = props.children,
      title = props.title;

  if (!title) {
    throw new Error('Cannot mount without any title on the page');
  }

  var titleWithHG = "".concat(title, " | HoneyGuide");

  function getMetaTags() {
    var metaTags = [{
      itemprop: 'name',
      content: titleWithHG
    }, {
      itemprop: 'description',
      content: description
    }, {
      itemprop: 'image',
      content: image
    }, {
      name: 'description',
      content: description
    }, // facebook og tags
    {
      property: 'og:title',
      content: titleWithHG
    }, {
      property: 'og:image',
      content: image
    }, {
      property: 'og:description',
      content: description
    }, {
      property: 'og:type',
      content: 'WebApp'
    }, // { property: 'og:site_name', content: SITE_URL, },
    // { property: 'og:url', content: `${SITE_URL}${pathname}`, },
    // { property: 'fb:app_id', content: FACEBOOK_APP_ID }
    // twitter tags
    {
      name: 'twitter:image:src',
      content: image
    }, {
      name: 'twitter:title',
      content: titleWithHG
    }, {
      name: 'twitter:description',
      content: description
    }, {
      name: 'twitter:image',
      content: image
    }];

    if (noCrawl) {
      metaTags.push({
        name: 'robots',
        content: 'noindex, nofollow'
      });
    }

    return metaTags;
  }

  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_reactHelmet["default"], {
    htmlAttributes: {
      lang: 'en',
      itemscope: undefined,
      itemtype: "http://schema.org/".concat(schema || 'WebPage')
    },
    title: titleWithHG,
    meta: getMetaTags(),
    link: canonicalUrl ? [{
      rel: 'canonical',
      href: canonicalUrl
    }] : []
  }), children);
}